import { ChakraProvider, Flex } from '@chakra-ui/react';
import { initializeGtm, useGetTheme } from '@repo/shared/shared';
import { CookieWidget } from '@repo/shared/widgets';
import { Viewport } from 'next';
import { appWithTranslation } from 'next-i18next';
import React from 'react';
import { theme as initialTheme } from '@/app/theme';
import { Footer } from '@/widgets/Footer';
import { GQLProvider } from '@/widgets/GQLProvider';
import { Header } from '@/widgets/header';
import { CartStoreProvider } from '@/entities/cart';
import { config } from '@/shared/constants';
import { Device } from '@/shared/enums';
import { parseSSGParams } from '@/shared/helpers';
import { useSaveLeadParams } from '@/shared/hooks';
import { GlobalStateProvider } from '@/shared/providers';
import type { AppProps } from 'next/app';

export const viewport: Viewport = {
  initialScale: 1,
  width: 'device-width',
};

initializeGtm(config.gtmId);

const MyApp = ({ Component, pageProps, router }: AppProps) => {
  const { device, isAds } = parseSSGParams(router.query);
  const isMobile = device === Device.MOBILE;

  useSaveLeadParams(isAds);

  const theme = useGetTheme(initialTheme);

  return (
    <ChakraProvider theme={theme}>
      <GlobalStateProvider isMobileInitValue={isMobile}>
        <CartStoreProvider>
          <GQLProvider>
            <Flex
              direction='column'
              minHeight='dvh100'
            >
              <Header />
              <Flex
                flexDirection='column'
                flexGrow={1}
              >
                <Component {...pageProps} />
              </Flex>
              <Footer />
              <CookieWidget
                cookieHref={`/cookie`}
                privacyHref={`/privacy`}
              />
            </Flex>
          </GQLProvider>
        </CartStoreProvider>
      </GlobalStateProvider>
    </ChakraProvider>
  );
};

const App: React.ComponentType<AppProps> = appWithTranslation(
  MyApp as React.ComponentType<AppProps>,
);

export default App;
